/* NUVA — bus de eventos ligero, sin app ni proveedor de analítica.
   ----------------------------------------------------------------
   Distingue los momentos que pidió el brief: view_detail,
   start_selection, finish_selection, save_selection_lead. add_to_cart,
   begin_checkout y purchase NO se disparan desde aquí todavía: viven
   en las plantillas nativas de carrito/checkout del tema (Horizon),
   que este proyecto no ha modificado — falta esa integración.

   window.nuvaDispatchEvent(name, detail) hace dos cosas:
   1) guarda el evento en window.nuvaEventLog (consultable en consola
      para verificar qué se disparó y cuándo).
   2) dispara un CustomEvent "nuva:event" en document, para que una
      herramienta de analítica real (GA4, Meta Pixel, Klaviyo, etc.)
      pueda escucharlo cuando se conecte — sin que este archivo
      dependa de ninguna de ellas. */
(function () {
  'use strict';
  window.nuvaEventLog = window.nuvaEventLog || [];
  window.nuvaDispatchEvent = function (name, detail) {
    var entry = { name: name, detail: detail || {}, at: new Date().toISOString() };
    window.nuvaEventLog.push(entry);
    document.dispatchEvent(new CustomEvent('nuva:event', { detail: entry }));
  };

  /* Autoenlace declarativo: cualquier elemento con
     data-nuva-track="view_detail" data-nuva-track-kit="store" dispara
     el evento correspondiente al hacer clic, sin JS adicional por
     sección (usado por "Las cinco opciones" y el comparador). */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-nuva-track]');
    if (!el) return;
    var name = el.getAttribute('data-nuva-track');
    var kit = el.getAttribute('data-nuva-track-kit');
    window.nuvaDispatchEvent(name, kit ? { kit: kit } : {});
  });
})();
